import React from 'react'

const SearchIcon = () => (
  <svg width="22" height="22">
    <path d="M21.414 18.586l-4.801-4.801A8.942 8.942 0 0 0 18 9a9 9 0 1 0-9 9 8.942 8.942 0 0 0 4.785-1.387l4.801 4.801c.39.391.902.586 1.414.586a2 2 0 0 0 1.414-3.414zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" fill="#41AADA" fillRule="nonzero" />
  </svg>
)

export default SearchIcon
